function initAnessaContent(){
  const deferredImages = document.querySelectorAll('img[data-anessa-src]:not([data-anessa-observed])');
  const loadImage = image => {
    image.src = image.dataset.anessaSrc;
    delete image.dataset.anessaSrc;
  };
  if ('IntersectionObserver' in window) {
    const mediaObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadImage(entry.target);
          mediaObserver.unobserve(entry.target);
        }
      });
    }, {rootMargin: '200px 0px'});
    deferredImages.forEach(image => {
      image.dataset.anessaObserved = 'true';
      mediaObserver.observe(image);
    });
  } else {
    deferredImages.forEach(loadImage);
  }


(function(){
  // Waist-based chart + US size. Source of truth = cm; inches + US for display. XS added 2026-08-18.
  var SIZES = [
    {label:"XS",  us:"0-2",   cmin:64,  cmax:69,  imin:25, imax:27},
    {label:"S",   us:"4-6",   cmin:71,  cmax:74,  imin:28, imax:29},
    {label:"M",   us:"8-10",  cmin:76,  cmax:81,  imin:30, imax:32},
    {label:"L",   us:"12-14", cmin:86,  cmax:94,  imin:34, imax:37},
    {label:"XL",  us:"16-18", cmin:99,  cmax:104, imin:39, imax:41},
    {label:"2XL", us:"20-22", cmin:107, cmax:112, imin:42, imax:44},
    {label:"3XL", us:"24-26", cmin:114, cmax:118, imin:45, imax:46},
    {label:"4XL", us:"28-30", cmin:119, cmax:122, imin:47, imax:48},
    {label:"5XL", us:"32-34", cmin:124, cmax:127, imin:49, imax:50}
  ];
  var overlay = document.getElementById('sbz-modal');
  if(!overlay || overlay.dataset.anessaInitialized) return;
  overlay.dataset.anessaInitialized='true';
  var calcUnit='in', chartUnit='in';
  function $(s){ return overlay.querySelector(s); }
  function $$(s){ return Array.prototype.slice.call(overlay.querySelectorAll(s)); }

  function open(){ overlay.hidden=false; document.body.style.overflow='hidden'; }
  function close(){ overlay.hidden=true; document.body.style.overflow=''; }
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-sbz-open]')){ open(); }
    else if(e.target.closest('[data-sbz-close]') || e.target===overlay){ close(); }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !overlay.hidden) close(); });

  function showTab(name){
    $$('.sbz-tab').forEach(function(t){ t.classList.toggle('is-active', t.getAttribute('data-sbz-tab')===name); });
    $$('.sbz-pane').forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-sbz-pane')===name); });
  }
  $$('.sbz-tab').forEach(function(tab){ tab.addEventListener('click', function(){ showTab(tab.getAttribute('data-sbz-tab')); }); });

  $$('.sbz-unit').forEach(function(group){
    var key = group.getAttribute('data-sbz-unit-group');
    group.querySelectorAll('.sbz-u').forEach(function(btn){
      btn.addEventListener('click', function(){
        group.querySelectorAll('.sbz-u').forEach(function(b){ b.classList.toggle('is-active', b===btn); });
        var u = btn.getAttribute('data-sbz-u');
        if(key==='calc'){ calcUnit=u; $('[data-sbz-suffix]').textContent=u; }
        if(key==='chart'){ chartUnit=u; renderTable(); }
      });
    });
  });

  // Works in CM. Arbitrates UPWARD: shared boundary returns the larger size,
  // and a measurement in a gap between two rows rounds up to the next size.
  function recommend(waistCm){
    var smallest = SIZES[0], largest = SIZES[SIZES.length-1];
    if(waistCm < smallest.cmin) return {size:smallest, status:'below'};
    if(waistCm > largest.cmax) return {size:largest, status:'above'};
    var match = null;
    for(var i=0;i<SIZES.length;i++){
      var s = SIZES[i];
      if(waistCm >= s.cmin && waistCm <= s.cmax){ match = s; }
    }
    if(match) return {size:match, status:'exact'};
    for(var j=0;j<SIZES.length;j++){
      if(SIZES[j].cmin > waistCm) return {size:SIZES[j], status:'between'};
    }
    return {size:largest, status:'exact'};
  }

  function runCalc(){
    var err=$('[data-sbz-error]'), res=$('[data-sbz-result]');
    err.hidden=true; res.hidden=true;
    var raw=($('#sbz-waist').value||'').toString().trim().replace(',', '.');
    var v=parseFloat(raw);
    if(isNaN(v) || v<=0){ err.textContent='Please enter your waist measurement.'; err.hidden=false; return; }
    var waistCm = calcUnit==='cm' ? v : v*2.54;
    if(waistCm<45 || waistCm>180){ err.textContent='That measurement looks off, please double-check.'; err.hidden=false; return; }
    var r = recommend(Math.round(waistCm));
    var smallest = SIZES[0], largest = SIZES[SIZES.length-1];
    var note;
    if(r.status==='above'){
      note = "Your measurement is above our largest size, so " + largest.label + " is the biggest fit we offer. Contact our support team and we'll help you get it right before you order.";
    } else if(r.status==='below'){
      note = "Your measurement is below our smallest size, so " + smallest.label + " is the closest fit we offer.";
    } else if(r.status==='between'){
      note = "You're between two sizes, so we've rounded up to " + r.size.label + " for the most comfortable fit.";
    } else {
      note = "Based on your waist, this is your best fit. Prefer a softer feel? You can size up.";
    }
    var guar = '<p class="guar">&#10003; Backed by our 90-day fit guarantee. Wrong size? We\'ll send the right one, free.</p>';
    res.innerHTML = '<p class="lbl">We recommend</p><div class="sz">'+r.size.label+'</div><p class="us">US '+r.size.us+'</p><p class="note">'+note+'</p>'+guar;
    res.hidden=false;
  }
  $('[data-sbz-calc]').addEventListener('click', runCalc);
  $('#sbz-waist').addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); runCalc(); } });

  function range(s){
    if(chartUnit==='cm'){ return s.cmin+'-'+s.cmax+' cm'; }
    return (s.imin===s.imax ? s.imin : s.imin+'-'+s.imax)+' in';
  }
  function renderTable(){
    var head='<tr><th>Size</th><th>US</th><th>Waist</th></tr>';
    var body=SIZES.map(function(s){ return '<tr><td>'+s.label+'</td><td>'+s.us+'</td><td>'+range(s)+'</td></tr>'; }).join('');
    $('[data-sbz-table]').innerHTML='<table class="sbz-table"><thead>'+head+'</thead><tbody>'+body+'</tbody></table>';
  }
  renderTable();

  function scrollToBundle(){
    var target = document.getElementById('anessa-buy-box') || document.querySelector('h1');
    if(target){ var top = target.getBoundingClientRect().top + window.pageYOffset - 120; window.scrollTo({top:top, behavior:'smooth'}); }
  }
  function goToBundle(){ close(); scrollToBundle(); }

  var bundleBtn = $('[data-sbz-bundle]');
  if(bundleBtn){ bundleBtn.addEventListener('click', goToBundle); }
  var altLink = $('[data-sbz-nomeasure]');
  if(altLink){ altLink.addEventListener('click', goToBundle); }
})();



  function setupSwipeTrack(track, cards, dots, activeClass, previous, next) {
    if (!track || track.dataset.anessaInitialized) return;
    track.dataset.anessaInitialized = 'true';
    let current = 0;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    function update() {
      current = Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
      dots.forEach((dot, index) => {
        dot.classList.toggle(activeClass, index === current);
        dot.setAttribute('aria-current', index === current ? 'true' : 'false');
      });
    }
    function go(index) {
      current = (index + cards.length) % cards.length;
      track.scrollTo({left: current * track.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth'});
    }
    dots.forEach((dot, index) => dot.addEventListener('click', () => go(index)));
    if (previous) previous.addEventListener('click', () => go(current - 1));
    if (next) next.addEventListener('click', () => go(current + 1));
    track.addEventListener('scroll', update, {passive:true});
    if (typeof ResizeObserver === 'function') {
      const observer = new ResizeObserver(() => {
        track.scrollTo({left:current * track.clientWidth, behavior:'instant'});
      });
      observer.observe(track);
    }
    update();
  }
  const reviewTrack = document.getElementById('sbReviewsTrack');
  if (reviewTrack) setupSwipeTrack(reviewTrack, Array.from(reviewTrack.children), Array.from(document.querySelectorAll('#sbReviewsDots .sb-dot')), 'sb-dot--active');
  const mediaTrack = document.getElementById('sbRevTrack');
  const mediaDots = document.getElementById('sbRevDots');
  if (mediaTrack && mediaDots && !mediaTrack.dataset.anessaInitialized) {
    mediaDots.replaceChildren();
    Array.from(mediaTrack.children).forEach((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'sb-rev-dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
      mediaDots.appendChild(dot);
    });
    setupSwipeTrack(mediaTrack, Array.from(mediaTrack.children), Array.from(mediaDots.children), 'is-active', document.getElementById('sbRevPrev'), document.getElementById('sbRevNext'));
  }


  function sbScrollToBundle() {
    var target = document.getElementById('anessa-buy-box') || document.querySelector('h1');
    if (target) {
      var top = target.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }


  function sbScrollToBundle() {
    var target = document.getElementById('anessa-buy-box') || document.querySelector('h1');
    if (target) {
      var top = target.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }


(function(){
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('.sbR-row').forEach(function(track){
    if(track.dataset.anessaInitialized) return;
    track.dataset.anessaInitialized='true';
    if(reduce.matches || window.matchMedia('(max-width: 749px), (pointer: coarse)').matches) return;
    var originals=Array.from(track.children), dir=Number(track.dataset.dir)||1;
    if(!originals.length) return;
    originals.forEach(function(card){ var clone=card.cloneNode(true); clone.setAttribute('aria-hidden','true'); track.appendChild(clone); });
    var resetPoint=0,paused=false,last=0;
    function measure(){ resetPoint=track.children[originals.length].offsetLeft-track.children[0].offsetLeft; if(dir<0&&track.scrollLeft<1) track.scrollLeft=resetPoint; }
    measure();
    var observer=typeof ResizeObserver==='function'?new ResizeObserver(measure):null;
    if(observer) observer.observe(track);
    track.addEventListener('mouseenter',function(){paused=true;});
    track.addEventListener('mouseleave',function(){paused=false;});
    track.addEventListener('touchstart',function(){paused=true;},{passive:true});
    track.addEventListener('touchend',function(){paused=false;},{passive:true});
    track.addEventListener('focusin',function(){paused=true;});
    track.addEventListener('focusout',function(){paused=false;});
    var fractional=0;
    function tick(now){
      if(!track.isConnected){if(observer)observer.disconnect();return;}
      var elapsed=last?Math.min(now-last,50):0;last=now;
      if(!paused&&!document.hidden&&!reduce.matches&&resetPoint>0){
        fractional+=24*elapsed/1000;
        var pixels=Math.floor(fractional);fractional-=pixels;
        track.scrollLeft+=dir*pixels;
        if(track.scrollLeft>=resetPoint)track.scrollLeft-=resetPoint;
        else if(track.scrollLeft<=0)track.scrollLeft+=resetPoint;
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  });
})();


  function sbScrollToBundle() {
    var target = document.getElementById('anessa-buy-box') || document.querySelector('h1');
    if (target) {
      var top = target.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }


  function sbScrollToBundle() {
    var target = document.getElementById('anessa-buy-box') || document.querySelector('h1');
    if (target) {
      var top = target.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initAnessaContent,{once:true});}else{initAnessaContent();}
document.addEventListener('shopify:section:load',initAnessaContent);
